import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../CSS/SendCommercialInvoiceDialog.css";

const SendCommercialInvoiceDialog = ({
  open,
  onClose,
  onClickSend,
  isLoading,
  showMessage,
  buttonText = "Send",
  title = "Send Invoice Flight Details Report",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "send-commercial-invoice-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="send-commercial-invoice-dialog-close"
          onClick={onClose}
        />
        <div className="send-commercial-invoice-dialog-content">
          <div
            className="send-commercial-invoice-dialog-title-container"
            style={{ marginBottom: "60px" }}
          >
            <div className="send-commercial-invoice-dialog-title">{title}</div>
            <div className="send-commercial-invoice-dialog-subtitle">{showMessage}</div>
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={!isLoading ? onClickSend : null}
            endIcon={isLoading ? <CircularProgress size={30} color="inherit" /> : null}
          >
            {buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SendCommercialInvoiceDialog;


